"use strict";

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});
var Types;

(function (Types) {
  Types["Button"] = "button";
  Types["Checkbox"] = "checkbox";
  Types["Color"] = "color";
  Types["Date"] = "date";
  Types["DatetimeLocal"] = "datetimeLocal";
  Types["Email"] = "email";
  Types["File"] = "file";
  Types["Hidden"] = "hidden";
  Types["Image"] = "image";
  Types["Month"] = "month";
  Types["Number"] = "number";
  Types["Password"] = "password";
  Types["Radio"] = "radio";
  Types["Range"] = "range";
  Types["Reset"] = "reset";
  Types["Search"] = "search";
  Types["Submit"] = "submit";
  Types["Tel"] = "tel";
  Types["Text"] = "text";
  Types["Time"] = "time";
  Types["Url"] = "url";
  Types["Week"] = "week";
})(Types || (Types = {}));

exports["default"] = Types;